import { Button } from "@carbon/react";

import { Select, TextInput } from "../../../ui";
import { SectionHeader } from "../../../components";

export const View = (props) => {
  return (
    <div className="onboarding-section">
      <SectionHeader
        title="Add your bank to receive payouts."
        subtitle="A payout is the transfer of earnings from your SwitchApp to your bank account."
      />

      <h5 className="form-section--title font-ctm--bold">Bank Details</h5>

      <TextInput disabled={!props.isActive} />

      <Select disabled={!props.isActive} />

      <Select disabled={!props.isActive} />

     
        {!props.isActive ? null : (
          <Button
            className="switchapp-themed onboarding-submit--button new-button"
            onClick={props.onSubmit}
          >
            Continue
          </Button>
        )}
      </div>
   
  );
};
